import colors from '../../assets/scss/variable/color.scss';

const ReportStates = {
  0: {
    id: "noReport",
    numericID: 0,
    symbol: "n",
    style: {
      backgroundColor: colors['noReport'],
      color: "#FFFFFF"
    }
  },
  1: {
    id: "drafted",
    numericID: 1,
    symbol: "d",
    style: {
      backgroundColor: colors['drafted'],
      color: colors['black']
    }
  },
  2: {
    id: "admitted",
    numericID: 2,
    symbol: "ad",
    style: {
      backgroundColor: colors['admitted'],
      color: colors['black']
    }
  },
  3: {
    id: "typed",
    numericID: 3,
    symbol: "t",
    style: {
      backgroundColor: colors['typed'],
      color: colors['black']
    }
  },
  4: {
    id: "accepted",
    numericID: 4,
    symbol: "a",
    style: {
      backgroundColor: colors['accepted'],
      color: colors['black']
    }
  },
  5: {
    id: "verified",
    numericID: 5,
    symbol: "v",
    style: {
      backgroundColor: colors['verified'],
      color: colors['black']
    }
  },
  6: {
    id: "sendToHIS",
    numericID: 6,
    symbol: "h",
    style: {
      backgroundColor: colors['sendToHIS'],
      color: colors['black']
    }
  },
  7: {
    id: "sendToPatient",
    numericID: 7,
    symbol: "s",
    style: {
      backgroundColor: colors['sendToPatient'],
      color: colors['black']
    },
  },
};

function getSymbol(statusID = 0) {
  return ReportStates[statusID].symbol;
}

function getID(statusID = 0) {
  return parseInt(ReportStates[statusID].numericID);
}

function getText(statusID = 0) {
  return ReportStates[statusID].id;
}

function getStyle(statusID = 0) {
  return ReportStates[statusID].style;
}

function getMenuStyle(statusID = 0) {
  return {...ReportStates[statusID].style,
    borderRadius: "2px",
  };
}

export {getSymbol, getText, getStyle, getID, getMenuStyle, ReportStates};
